var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
var RadioGroup = /** @class */ (function (_super) {
    __extends(RadioGroup, _super);
    function RadioGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChoose = function (value) {
            _this.setState({ selectedOption: value }, function () {
                _this.props.onChange && _this.props.onChange(value);
            });
        };
        return _this;
    }
    RadioGroup.prototype.render = function () {
        if (this.props.style || this.props.className) {
            return (React.createElement("div", { style: this.props.style, className: this.props.className }, this.props.children({ onSelectItem: this.handleChoose })));
        }
        return this.props.children({ onSelectItem: this.handleChoose });
    };
    return RadioGroup;
}(Component));
export default RadioGroup;



//////////////////
// WEBPACK FOOTER
// ./src/components/RadioGroup/RadioGroup.tsx
// module id = 1476
// module chunks = 0